import Cookie from "../src/cookie.js";
import { newTracker, trackPageView, setUserId, trackSelfDescribingEvent, addGlobalContexts } from "@snowplow/browser-tracker";
import { EcommercePlugin } from "@snowplow/browser-plugin-ecommerce";
import { setupTracking } from "kaleido-event-tracker";

const snowplowConfig = JSON.parse(document.querySelector("meta[property='snowplow']").getAttribute("content"));

const pageViewsEndpoint = snowplowConfig.page_views_endpoint;
const pageViewsIdentifier = snowplowConfig.page_views_identifier;

if (snowplowConfig.enabled) {
  newTracker(pageViewsIdentifier, pageViewsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
  });

  const customEventsEndpoint = snowplowConfig.custom_events_endpoint;
  const customEventsIdentifier = snowplowConfig.custom_events_identifier;

  newTracker(customEventsIdentifier, customEventsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
    plugins: [EcommercePlugin()],
  });

  const userEventsEndpoint = snowplowConfig.user_events_endpoint;
  const userEventsIdentifier = snowplowConfig.user_events_identifier;

  newTracker(userEventsIdentifier, userEventsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
  });

  const contextEntity = {
    schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/context/rbg_global_context/jsonschema/1-0-0.json",
    data: {
      vcs_ref: snowplowConfig.vcs_ref,
      build_date: snowplowConfig.build_date,
      version: snowplowConfig.version,
      rbg_feature_flags: snowplowConfig.rbg_feature_flags,
      rbg_experiments: snowplowConfig.rbg_experiments,
    },
  };

  const allTrackers = [pageViewsIdentifier, customEventsIdentifier, userEventsIdentifier];

  addGlobalContexts([contextEntity], allTrackers);
  setUserId(snowplowConfig.user_id, allTrackers);
  setupTracking(trackSelfDescribingEvent, [userEventsIdentifier], snowplowConfig.custom_events_enabled);

  trackPageView({}, [pageViewsIdentifier]);
} else {
  const noOpTracker = () => {};
  setupTracking(noOpTracker, [], false);
}
